export default "__VITE_ASSET__CQWtbnym__"